/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findOneProgramPeriodConfig } from '../fn/program-period-configs/find-one-program-period-config';
import { FindOneProgramPeriodConfig$Params } from '../fn/program-period-configs/find-one-program-period-config';
import { ProgramPeriodConfig } from '../models/program-period-config';

@Injectable({ providedIn: 'root' })
export class ProgramPeriodConfigsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `programPeriodConfigControllerFindOneProgramPeriodConfig()` */
  static readonly ProgramPeriodConfigControllerFindOneProgramPeriodConfigPath = '/program-period-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneProgramPeriodConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneProgramPeriodConfig$Response(
    params: FindOneProgramPeriodConfig$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProgramPeriodConfig>> {
    return findOneProgramPeriodConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOneProgramPeriodConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneProgramPeriodConfig(
    params: FindOneProgramPeriodConfig$Params,
    context?: HttpContext
  ): Observable<ProgramPeriodConfig> {
    return this.findOneProgramPeriodConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramPeriodConfig>): ProgramPeriodConfig => r.body)
    );
  }
}
